'use client';

import { useState } from 'react';

import { useRouter } from 'next/navigation';

import { routes } from '@/features/v2/constants/routes';

import { HButton } from '@/stories/atoms/buttons/mainButton/Button';
import HNavbar from '@/stories/organisms/navbar/Navbar';

const NavbarPublic = () => {
  const router = useRouter();
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isRegisterLoading, setIsRegisterLoading] = useState(false);

  const handleLoginClick = () => {
    setIsLoginLoading(true);
    router.push(routes.LOGIN);
  };

  const handleRegisterClick = () => {
    setIsRegisterLoading(true);
    router.push(routes.REGISTER);
  };

  return (
    <HNavbar
      content={(
        <div className="flex gap-1 md:gap-2">
          <HButton
            label={isLoginLoading ? 'Cargando...' : 'Ingresa'}
            size="large"
            mode="secondary"
            disabled={isLoginLoading || isRegisterLoading}
            aria-label="Iniciar sesión en Powerbet"
            isLoading={isLoginLoading}
            onPress={handleLoginClick}
          />
          <HButton
            label={isRegisterLoading ? 'Cargando...' : 'Registro'}
            size="large"
            mode="primary"
            disabled={isLoginLoading || isRegisterLoading}
            aria-label="Registrarse en Powerbet"
            isLoading={isRegisterLoading}
            onPress={handleRegisterClick}
          />
        </div>
      )}
      position="end"
    />
  );
};

export default NavbarPublic;
